import React from 'react';
import { observer } from 'mobx-react';
import { Spinner, Divisor } from 'components';
import { useAppManager } from 'core/hooks';
import type CreateShipmentQuoteAppManager from 'apps/shipmentQuote/appManager';

import { NewProductQuote } from 'apps/productQuote/NewProductQuote';
import { columns } from 'apps/productQuote/ProductQuoteTables';
import { ProductQuoteApp } from 'apps/productQuote/app';
import { TableSection } from 'apps/productQuote/ProductQuoteTables/TableSection';
// import { ProductQuoteHeader } from 'apps/productQuote/ProductQuoteHeader';
import { ProductQuoteAppManager } from 'apps/productQuote/productQuoteAppManager';
import { LargePanelSectionWrapper } from 'libs/rendering/gltf/components/largePanel/styles';
import { RowActionButtons } from './RowActionButtons';
import { ShipmentQuoteButton } from './ShipmentQuoteButton';

// function getCheckBoxColumn(shipmentQuoteAppManager: CreateShipmentQuoteAppManager) {
//   return {
//     Header: '',
//     accessor: '',
//     // for some reason this 'any' type annotation is necessary
//     Cell: function checkbox(productQuote: ProductQuoteApp) {
//       const handleChange = () => {
//         // change the URL to add the ProductQuote ids
//         shipmentQuoteAppManager.AddOrRemoveProductQuoteId(productQuote);
//       };
//       const pqids = routerStore.params.get('pqids') || [];
//       return (
//         <Checkbox
//           onChange={handleChange}
//           checked={pqids.includes(productQuote.dgraphId)}
//           value={productQuote.dgraphId}
//           id={productQuote.dgraphId}
//         />
//       );
//     },
//   };
// }

interface ProductQuoteProps {
  shipmentQuoteAppManager: CreateShipmentQuoteAppManager;
  productQuoteApp: ProductQuoteApp;
  onModalClose: () => void;
  // t: (key: string) => string;
  rfqApp: any; // TODO
}

export const IntermediatorRFQProductQuotes = observer(
  function IntermediatorRFQProductQuotes({
    // shipmentQuoteAppManager,
    // productQuoteApp,
    rfqApp,
  }: ProductQuoteProps) {
    const productQuoteAppManager = useAppManager(ProductQuoteAppManager, null, {
      fromRFQ: rfqApp,
    });
    const finalColumns = columns.slice(3);
    const productQuotes = productQuoteAppManager.productQuotes || [];
    const { loading } = productQuoteAppManager.productQuotesQ;
    const customerSlug = rfqApp.customerSpace.path;

    // const warningMessage =
    //   shipmentQuoteAppManager.numSelectedPqs > 1 ? (
    //     <Box sx={{ width: '100%' }}>
    //       <Banner variant='warning' size='small'>
    //         Warning: you have added more than one quote for the same RFQ.
    //         That&apos;s unusual but valid if e.g. you are quoting both a mould
    //         and a production run.
    //       </Banner>
    //     </Box>
    //   ) : null;

    return (
      <LargePanelSectionWrapper>
        {/* <ProductQuoteHeader productQuoteApp={productQuoteApp} /> */}
        {(productQuotes.length !== 0 && (
          <TableSection
            loading={false}
            columns={finalColumns}
            nodes={productQuotes}
            title='Part Quotes (internal)' // t('Part Quotes (internal)')
            RowActionButtons={props => {
              return (
                <RowActionButtons
                  {...props}
                  appManager={productQuoteAppManager}
                />
              );
            }}
            emptyTablePlaceholder={null}
            isDivisorVisible={false}
          />
        )) ||
          (loading && <Spinner margin='1rem 0' />)}
        <ShipmentQuoteButton
          customerSlug={customerSlug}
          rfqId={rfqApp.dgraphId}
        />
        <Divisor mt={8} />
        <NewProductQuote
          productQuoteManager={productQuoteAppManager}
          inRfqPage
        />
      </LargePanelSectionWrapper>
    );
  },
);
